export default __webpack_public_path__ + "static/media/patent.8b293a38.png";